// Module
var code = "<div class=\"list-actions\"> <span ng-click=\"$ctrl.editClick()\" title=\"Edit Team\" data-testid=\"edit-team-button\" class=\"list-actions__action\"> <i class=\"fa-light fa-pencil\"></i> </span> <span ng-click=\"$ctrl.deleteClick()\" title=\"Delete Team\" class=\"list-actions__action\"> <i class=\"fa-light fa-trash-can\"></i> </span> </div> ";
// Exports
export default code;